import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { mucHoTroNhaNuocApi } from "../../../api/category/mucHoTroNhaNuocApi";
import {
  IDmMucHoTroNhaNuoc,
  IDmMucHoTroNhaNuocCopyRequest,
  IDmMucHoTroNhaNuocSelectRequest,
} from "../../../model/respone/category/IDmMucHoTroNhaNuoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmMucHoTroNhaNuocActionIds,
  IDmMucHoTroNhaNuocActionTypes,
} from "../../action-types/category/IDmMucHoTroNhaNuocActions";
import { NotifyHelper } from "../../../helpers/toast";
import { rootActions } from "../../actions/rootActions";

export function* mucHoTroNhaNuocSaga(): any {
  yield takeLatest(eDmMucHoTroNhaNuocActionIds.LOAD_START, loadWorker);
  yield takeEvery(
    eDmMucHoTroNhaNuocActionIds.SAVE_MULTIPLE_START,
    saveMultipleWorker,
  );
  yield takeEvery(eDmMucHoTroNhaNuocActionIds.COPY_START, copyWorker);
}

function* loadWorker(action: IDmMucHoTroNhaNuocActionTypes): any {
  const res: IBaseRespone = yield call(
    mucHoTroNhaNuocApi.Select,
    action.payload as IDmMucHoTroNhaNuocSelectRequest,
  );
  if (res?.is_success) {
    yield put(rootActions.category.mucHoTroNhaNuoc.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.mucHoTroNhaNuoc.LOAD_ERROR(res?.message ?? "Có lỗi"),
    );
  }
}

function* saveMultipleWorker(action: IDmMucHoTroNhaNuocActionTypes): any {
  const res: IBaseRespone = yield call(
    mucHoTroNhaNuocApi.Saves,
    action.payload as IDmMucHoTroNhaNuoc[],
  );
  if (res?.is_success) {
    yield put(rootActions.category.mucHoTroNhaNuoc.SAVE_MULTIPLE_SUCCESS(true));
  } else {
    yield put(
      rootActions.category.mucHoTroNhaNuoc.SAVE_MULTIPLE_ERROR(
        res?.message ?? "Lưu thất bại",
      ),
    );
  }
}

function* copyWorker(action: IDmMucHoTroNhaNuocActionTypes): any {
  const res: IBaseRespone = yield call(
    mucHoTroNhaNuocApi.Copy,
    action.payload as IDmMucHoTroNhaNuocCopyRequest,
  );
  if (res?.is_success) {
    // Máy chủ trả về SỐ DÒNG đã chép — nói rõ để người dùng biết có chép được gì không,
    // chép 0 dòng (kỳ nguồn chưa khai gì) mà chỉ báo "thành công" thì rất dễ hiểu nhầm.
    const soDong = Number(res.data ?? 0);
    if (soDong > 0)
      NotifyHelper.Success(`Đã sao chép ${soDong} dòng mức hỗ trợ`);
    else
      NotifyHelper.Warning("Kỳ nguồn chưa khai mức hỗ trợ nào — không có gì để chép");
    yield put(rootActions.category.mucHoTroNhaNuoc.COPY_SUCCESS(soDong));
  } else {
    NotifyHelper.Error(res?.message ?? "Sao chép thất bại");
    yield put(
      rootActions.category.mucHoTroNhaNuoc.COPY_ERROR(
        res?.message ?? "Sao chép thất bại",
      ),
    );
  }
}
